export default __webpack_public_path__ + "static/media/vc.f41b1aa5.png";